export const EMAIL = 'EMAIL';
export const SLACK = 'SLACK';
export const ZAPIER = 'ZAPIER';
